import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SapCard from "./../Components/SapCard/index.jsx";
import './index.css';
import { api } from './../../services/api.js';
import Loading from "../../comum/Layout/loading.jsx";
import SweetAlert from 'react-bootstrap-sweetalert';
import { AuthContext } from '../../comum/Context/auth.jsx';
import Menu from "../../comum/Menu/index.jsx";
import Footer from '../../comum/Footer/index.jsx';


function Sap() {
    const { logado } = useContext(AuthContext);
    const [tabelas, setTabelas] = useState([]);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [aprovacao, setAprovacao] = useState(false);
    const [negacao, setNegacao] = useState(false);
    const [confirmacaoId, setConfirmacaoId] = useState('');
    const [atualizado, setAtualizado] = useState('');
    const [nome, setNome] = useState('');
    const [erro, setErro] = useState('');
    const [datahora, setData] = useState('');
    const [sucesso, setSucesso] = useState(true);
    const [selecionados, setSelecionados] = useState([]);
    const [todosSelecionados, setTodosSelecionados] = useState(false);

    const [sap_loja, setSap_Loja] = useState(0);
    const [sap_codigo, setSap_Codigo] = useState(0);
    const [sap_data, setSap_data] = useState('');
    const [sap_preco, setSap_Preco] = useState('');
    const [sap_sequencia, setSap_Sequencia] = useState('');
    const [sap_descricao, setSap_Descricao] = useState('');
    const chapa = localStorage.getItem("chapa");
    const [precosEditados, setPrecosEditados] = useState({});
    const navigate = useNavigate();

    // Novo estado para o SweetAlert de permissão
    const [permissaoNegada, setPermissaoNegada] = useState(false);

    useEffect(() => {
        const chapa = localStorage.getItem("chapa");
        if (!chapa) {
            navigate("/arbor/login"); // Redireciona se não for funcionário logado
        }
    }, []);

    // Novo useEffect para verificar a permissão
    useEffect(() => {
        const sapAdmin = localStorage.getItem("SAPADM");
        if (sapAdmin !== "S") {
            setPermissaoNegada(true);
        }
    }, []);

    function formatNumber(num) {
        return num.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }

    function confirmAprovar(data, loja, sequencia, codigo, descricao, preco) {
        setAprovacao(true);
        setConfirmacaoId(chapa);
        setSap_Sequencia(sequencia);
        setSap_Loja(loja);
        setSap_Codigo(codigo);
        setSap_data(data);
        setSap_Preco(preco);
        setSap_Descricao(descricao);
    }

    function confirmNegar(data, loja, sequencia, codigo, descricao, preco) {
        setNegacao(true);
        setConfirmacaoId(chapa);
        setSap_Sequencia(sequencia);
        setSap_Loja(loja);
        setSap_Codigo(codigo);
        setSap_data(data);
        setSap_Preco(preco);
        setSap_Descricao(descricao);
    }

    const onPrecoEditadoChange = (loja, codigo, sequencia, precoEditado) => {
        const key = `${loja}-${codigo}-${sequencia}`;
        const precoUsar = precosEditados[key] !== undefined ? precosEditados[key] : parseFloat(sap_preco);
        setPrecosEditados(prev => {
            const originalItem = tabelas.find(item =>
                item.sap_loja === loja && item.sap_codigo === codigo && item.sap_sequencia === sequencia
            );
            if (!originalItem) return prev;
            if (precoEditado === originalItem.sap_precosolicitado) {
                const copy = { ...prev };
                delete copy[key];
                return copy;
            } else {
                return { ...prev, [key]: precoEditado };
            }
        });
    };

    function aprovaSAP() {
        setAprovacao(false);
        setNegacao(false);

        const key = `${sap_loja}-${sap_codigo}-${sap_sequencia}`;
        const precoUsar = precosEditados[key] !== undefined ? precosEditados[key] : parseFloat(sap_preco);

        const data = {
            chapa,
            sequencia: sap_sequencia,
            loja: sap_loja,
            codigo: sap_codigo,
            datasol: sap_data,
            inicio: null,
            fim: null,
            preco: formatNumber(parseFloat(precoUsar)),
            status: "A"
        };
        console.log(data);
        api.post('/SAP/atualiza', data)
            .then(() => {
                setPrecosEditados(prev => {
                    const copy = { ...prev };
                    delete copy[key];
                    return copy;
                });
                setAtualizado(Date.now());
            })
            .catch(err => setErro("Erro na liberação:" + err));
    }

    function negaSAP(motivo) {
        const data = {
            chapa,
            sequencia: sap_sequencia,
            loja: sap_loja,
            codigo: sap_codigo,
            datasol: sap_data,
            inicio: null,
            fim: null,
            preco: 0,
            status: "N",
            motivo
        };
        api.post('/SAP/atualiza', data)
            .then(() => {
                // Fecha o SweetAlert de negação aqui
                setNegacao(false);
                setAtualizado(Date.now());
            })
            .catch(err => setErro(err.response.data.erro));
    }

    const handleSelecionar = (checked, item) => {
        if (checked) setSelecionados(prev => [...prev, item]);
        else setSelecionados(prev => prev.filter(s => s.loja !== item.loja || s.codigo !== item.codigo || s.sequencia !== item.sequencia));
    };

    const selecionarTodos = () => {
        const todos = tabelas.map(tabela => {
            const key = `${tabela.sap_loja}-${tabela.sap_codigo}-${tabela.sap_sequencia}`;
            const preco = precosEditados[key] !== undefined ? precosEditados[key] : tabela.sap_precosolicitado;
            return {
                loja: tabela.sap_loja,
                codigo: tabela.sap_codigo,
                datasol: tabela.sap_data,
                sequencia: tabela.sap_sequencia,
                preco,
                descricao: tabela.sap_descricao
            };
        });
        setSelecionados(todos);
        setTodosSelecionados(true);
    };

    const desmarcarTodos = () => {
        setSelecionados([]);
        setTodosSelecionados(false);
    };

    const autorizarTodosSelecionados = async () => {
        for (const item of selecionados) {
            const data = {
                chapa,
                loja: item.loja,
                codigo: item.codigo,
                datasol: item.datasol,
                sequencia: item.sequencia,
                preco: formatNumber(parseFloat(item.preco)),
                status: "A",
                inicio: null,
                fim: null
            };
            try {
                console.log(data);
                await api.post('/SAP/atualiza', data);
            } catch (err) {
                console.error("Erro ao autorizar item:", item, err);
            }
        }
        setSelecionados([]);
        setTodosSelecionados(false);
        setAtualizado(Date.now());
    };

    useEffect(() => {
        setRemoveLoading(false);
        setErro('');
        api.get('/SAP/consulta/' + chapa)
            .then(response => {
                setTabelas(response.data);
                console.log(tabelas);
                setRemoveLoading(true);
            })
            .catch(err => {
                setRemoveLoading(true);
                setErro(err.response.data.erro);
            });
    }, [datahora, atualizado]);

    // Lógica para renderizar o SweetAlert
    if (permissaoNegada) {
        return (
            <SweetAlert
                danger
                title="Acesso negado"
                onConfirm={() => navigate("/")} // Ou outra rota
                confirmBtnText="OK"
            >
                Você não tem permissão para acessar esta página.
            </SweetAlert>
        );
    }

    return (<div>
        <Menu modulo="SAP" />
        <div className="pagina-home container-fluid">
            {tabelas.length > 1 && !todosSelecionados && (
                <div className="mb-3">
                    <button className="btn btn-warning btn-flutuante_esq" onClick={selecionarTodos}>
                        <i className="fa fa-check-square"></i> Selecionar Todos
                    </button>
                </div>
            )}
            {todosSelecionados && (
                <button
                    className="btn btn-danger btn-flutuante_esq"
                    onClick={desmarcarTodos}
                >
                    <i className="fa fa-times"></i> Desmarcar Todos ({selecionados.length})
                </button>
            )}
            {selecionados.length > 0 && (
                <button
                    className="btn btn-primary btn-flutuante"
                    style={{ bottom: todosSelecionados ? '70px' : '15px', left: '15px' }}
                    onClick={autorizarTodosSelecionados}
                >
                    <i className="fa fa-check"></i> Autorizar Todos ({selecionados.length})
                </button>
            )}
            <div className="row">
                {tabelas.map((tabela) => (
                    <div className="col-lg-2 col-md-12 col-sm-12 col-6" key={`${tabela.sap_loja}_${tabela.sap_codigo}_${tabela.sap_sequencia}`} >
                        <SapCard
                            {...tabela}
                            clickAprovar={confirmAprovar}
                            clickNegar={confirmNegar}
                            onSelecionar={handleSelecionar}
                            selecionado={selecionados.some(s => s.loja === tabela.sap_loja && s.codigo === tabela.sap_codigo && s.sequencia === tabela.sap_sequencia)}
                            onPrecoEditadoChange={onPrecoEditadoChange}
                        />
                    </div>
                ))}
                {tabelas.length === 0 && <div className="no-item">Sem registros de Solicitações de preço</div>}
            </div>

            {aprovacao && (
                <SweetAlert
                    success showCancel showCloseButton
                    confirmBtnText="Sim" cancelBtnText="Não"
                    onConfirm={aprovaSAP} onCancel={() => setAprovacao(false)}
                    title="Confirmação"
                >
                    {sap_descricao} pelo preço de {formatNumber(sap_preco)}?
                </SweetAlert>
            )}
            {negacao && (
                <SweetAlert
                    input showCancel showCloseButton
                    confirmBtnText="Confirmar" cancelBtnText="Cancelar"
                    onConfirm={negaSAP} onCancel={() => setNegacao(false)}
                    title="Motivo"
                >
                    Informe o motivo de reprovação do preço {formatNumber(sap_preco)} para o produto {sap_descricao}!
                </SweetAlert>
            )}
            {erro && (
                <SweetAlert
                    danger showCloseButton confirmBtnText="OK"
                    onConfirm={() => setErro('')}
                    title="Falha"
                >Erro: {erro}</SweetAlert>
            )}
            {removeLoading && <Footer className="footer navbar-fixed-bottom" />}
        </div>
    </div>);
}

export default Sap;